import { twJoin } from "tailwind-merge";

type BluePillProps = {
  percentage: number;
};

export function BluePill({ percentage }: BluePillProps): React.ReactNode {
  if (percentage === 0) {
    return null;
  }

  return (
    <span
      className={twJoin(
        "ml-space-sm inline-flex rounded-full px-space-sm py-px text-overline whitespace-nowrap",
        percentage < 0
          ? "bg-background-danger-secondary/50 text-text-danger-secondary"
          : "bg-background-success-secondary text-text-on-success-secondary",
      )}
    >
      {percentage < 0 ? "-" : "+"} {Math.abs(percentage)}%
    </span>
  );
}
